import styled from 'styled-components';

const OrganisationMenuItem = styled.div`
  display: flex;
  align-items: center;
`;

const OrganisationName = styled.div`
  padding-left: 8px;
`;

export { OrganisationName, OrganisationMenuItem };
